import React, { useEffect, useState } from 'react'
import classnames from 'classnames'
import { Button } from 'antd'
import notEligibleIcon from '../img/ic-not-eligible.svg'
import { useI18n } from 'contexts/AuthContext'
import ContentHeader from '../ContentHeader'
import { useMCA } from './useMCA'
import { ScreenKey } from '../util'
import { getAutoLoginParams, isMobile, showNotification } from 'utils/basic'
import { getFitOnHost } from 'apis/formatUrl'
import { mcaScreenerPromise } from 'apis/FitOnCareAPI'
import { getUserEmail } from 'utils/authLocalStorage'

const AlignmentFailed = (props) => {
  const { sku, setCurrentKey } = props
  const [currentFitonUserId, setCurrentFitonUserId] = useState()
  const { i18n } = useI18n()
  const { alignRetrySideEffects, alignTracks, getMcaEnrollment } = useMCA({
    sku,
  })

  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (sku === 'mca') {
      setIsLoading(true)
      mcaScreenerPromise()
        .then((resp) => {
          const fitonUserId = resp.data?.fitonUserId?.toString()
          setCurrentFitonUserId(fitonUserId)
        })
        .finally(() => {
          setIsLoading(false)
        })
    }
  }, [sku])

  const onBack = (e) => {
    props.onBack(e)
  }
  // Two failure modes land on this screen:
  //   (a) status=alignment_failed — CMS aligned but side-effects failed (cms_alignment_id
  //       is set) → replay side-effects via /align/retry-side-effects.
  //   (b) a transient $align failure that kept the row cms_eligible → re-run the full
  //       /align. Re-running /align on an alignment_failed row would be rejected, so branch
  //       on the current row status.
  const onTryAgain = async () => {
    setIsLoading(true)
    const data = await getMcaEnrollment()
    const enrollment = data?.enrollment
    const nextScreenKey =
      enrollment?.status === 'alignment_failed'
        ? await alignRetrySideEffects()
        : await alignTracks({
            acceptedTracks:
              enrollment?.acceptedTracks || enrollment?.candidateTracks || [],
            participationVoluntary: true,
            oneParticipantPerTrack: true,
            mayDisenrollAfter90Days: true,
            costSharingAcknowledged: true,
          })
    if (nextScreenKey) {
      if (nextScreenKey === ScreenKey.MCA_ALIGNMENT_FAILED) {
        showNotification({
          type: 'error',
          title: i18n('Oops something went wrong'),
          message: i18n('Please try again later'),
        })
      }
      setCurrentKey(nextScreenKey)
    }
    setIsLoading(false)
  }
  const backToApp = () => {
    window.location.href = `${getFitOnHost()}?${getAutoLoginParams({ fitOnUserId: currentFitonUserId, fitOnEmail: getUserEmail() })}`
  }

  return (
    <div className={classnames('info-sec')}>
      <ContentHeader {...props} onBack={onBack} />
      <div className='info-content'>
        <img src={notEligibleIcon} alt='' className='top-icon' />
        <div className='title-pns'>{i18n('Oops something went wrong')}</div>
        <div
          className='subtitle'
          style={{
            marginBottom: '10px',
            marginTop: '17px',
            marginLeft: '0',
            marginRight: '0',
          }}
        >
          {i18n(
            'Please try again. If the problem persists, contact customer support'
          )}
        </div>
        <Button
          className='btn-primary full-width-btn'
          style={{ marginTop: '32px', color: '#333333', width: '100%' }}
          onClick={onTryAgain}
          loading={isLoading}
        >
          {i18n('Retry')}
        </Button>
        <Button
          className='btn-cancel full-width-btn'
          style={{ marginTop: '16px', color: '#333333', width: '100%' }}
          onClick={backToApp}
        >
          {i18n('Back to App')}
        </Button>
      </div>
    </div>
  )
}

export default AlignmentFailed
